// src/Utils/urineColors.js
// Urine Color is observed by the technician, not read off the strip, so it is
// picked from a swatch dropdown instead of being typed/fetched.
// `value` is what the result API receives; `label` and `hex` are display only.

export const URINE_COLOR_PARAMETER_ID = "KIU7412";

export const URINE_COLOR_OPTIONS = [
  { value: "COLORLESS", label: "Colorless", hex: "#F8FBFF" },
  { value: "PALE_YELLOW", label: "Pale Yellow (Straw)", hex: "#FFF2A6" },
  { value: "YELLOW", label: "Yellow", hex: "#FFD84A" },
  { value: "DARK_YELLOW", label: "Dark Yellow", hex: "#D9AA00" },
  { value: "AMBER", label: "Amber", hex: "#B86F00" },
  { value: "ORANGE", label: "Orange", hex: "#DC6B1C" },
  { value: "PINK", label: "Pink", hex: "#E79AA6" },
  { value: "RED", label: "Red", hex: "#A63A37" },
  { value: "BROWN_TEA", label: "Brown / Tea-colored", hex: "#6B4423" },
  { value: "GREEN", label: "Green", hex: "#5F8150" },
  { value: "BLUE_GREEN", label: "Blue / Blue-green", hex: "#3F7F86" },
  { value: "PURPLE", label: "Purple", hex: "#71517E" },
  { value: "WHITE_MILKY", label: "White / Milky", hex: "#EEEBDD" },
  { value: "BLACK", label: "Black", hex: "#211F1B" },
];

const URINE_COLOR_BY_VALUE = URINE_COLOR_OPTIONS.reduce((acc, option) => {
  acc[option.value] = option;
  return acc;
}, {});

export const getUrineColorOption = (value) => {
  if (typeof value !== "string") return null;
  const key = value.trim().toUpperCase();
  return URINE_COLOR_BY_VALUE[key] || null;
};

export const getUrineColorLabel = (value) =>
  getUrineColorOption(value)?.label || "";

// Match on ParameterID first, falling back to the name so the picker still
// renders if the panel is served with a different id.
export const isUrineColorParam = (detail) => {
  const parameterId = (detail?.ParameterID || "").trim().toUpperCase();
  if (parameterId === URINE_COLOR_PARAMETER_ID) return true;

  const name = (detail?.name || "").trim().toLowerCase();
  return name === "urine color" || name === "urine colour";
};
